import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { api } from "../../../_services/api.service";
import Loader from "react-loaders";
import { Card, CardBody, Row, Col, CustomInput } from "reactstrap";

const AlternativeAverageBarChart = ({ partnerScenarioId }) => {
  const alternativeTypes = [
    {
      name: "All",
      value: 3,
    },
    {
      name: "Custom",
      value: 1,
    },
    {
      name: "Suggested",
      value: 2,
    },
  ];
  let [selectedAlternativeType, setSelectedAlternativeType] = useState(3); // All = 3, Custom = 2, Suggested = 1
  let [limit, setLimit] = useState("-1"); // -1 means "All"
  let [isLoading, setIsLoading] = useState(true);
  let [partnerScenarioChartAltAvgData, setPartnerScenarioChartAltAvgData] =
    useState([]);

  let [chartHeight, setChartHeight] = useState(300);
  let [barChartAltAvgOptions, setBarChartAltAvgOptions] = useState({
    chart: {
      id: "bar",
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    xaxis: {
      categories: [],
    },
  });
  let [barChartAltAvgSeries, setBarChartAltAvgSeries] = useState([
    { data: [] },
  ]);

  const [barChartAltAvgOptionsSeries, setBarChartAltAvgOptionsSeries] =
    useState(null);

  useEffect(() => {
    if (partnerScenarioId > 0) {
      setIsLoading(true);
      api
        .getPartnerChartAltAvg(
          partnerScenarioId,
          parseInt(selectedAlternativeType, 10),
          parseInt(limit, 10)
        )
        .then((data) => {
          setIsLoading(false);
          setPartnerScenarioChartAltAvgData(data);
          populateBarChartAltAvg(data);
        });
    } else {
      setIsLoading(false);
    }
  }, [selectedAlternativeType, limit]);

  const populateBarChartAltAvg = (list) => {
    let options = {
      chart: {
        type: "bar",
        height: 350,
        // stacked: false,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
      xaxis: {
        type: "string",
        categories: [],
        labels: {
          formatter: function (val) {
            return `${parseInt(val)}%`;
          },
        },
      },
      legend: {
        position: "right",
        offsetY: 40,
      },
      fill: {
        opacity: 1,
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opt) {
          return isNaN(parseInt(val)) ? "" : parseInt(val) + "%";
        },
        offsetX: 0,
      },
      tooltip:{
        y:{
          formatter: function(val) {
            return isNaN(parseInt(val)) ? "" : parseInt(val) + "%";
          }
        }
      }
    };
    let series = [];

    let height = 20;

    list.forEach((x) => {
      options.xaxis.categories.push(x.alternativeName);
      series.push(x.alternativeScore);
      height += 50;
    });

    setChartHeight(height);

    setBarChartAltAvgOptionsSeries({ options, series: [{ data: series }] });
  };

  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day].join("/");
  };

  return (
    <>
      <Card className="main-card mb-3">
        <CardBody>
          {isLoading && <Loader style={{}} type="ball-pulse" active />}
          {!isLoading && barChartAltAvgOptionsSeries != null && (
            <ReactApexChart
              options={barChartAltAvgOptionsSeries.options}
              series={barChartAltAvgOptionsSeries.series}
              type="bar"
              height={`${chartHeight}px`}
            />
          )}

          <Row>
            <Col md="6">
              <span>Type</span>
              <div className="form-group">
                <CustomInput
                  type="select"
                  id="selectedAltTypeid"
                  value={selectedAlternativeType}
                  name="selectedAltTypeidd"
                  onChange={(e) => {
                    setSelectedAlternativeType(e.target.value);
                  }}
                >
                  {alternativeTypes.map((x) => {
                    return (
                      <option key={"ii" + x.value} value={x.value}>
                        {x.name}
                      </option>
                    );
                  })}
                </CustomInput>
              </div>
            </Col>
            <Col md="6">
              <div className="form-group">
                <span>Show</span>
                <CustomInput
                  type="select"
                  id="visibleRowsId"
                  value={limit}
                  name="visibleRowsId"
                  onChange={(e) => {
                    setLimit(e.target.value);
                  }}
                >
                  {[
                    { value: "5", name: "Top 5" },
                    { value: "10", name: "Top 10" },
                    { value: "20", name: "Top 20" },
                    { value: "-1", name: "All" },
                  ].map((x) => {
                    return (
                      <option key={"ii" + x.value} value={x.value}>
                        {x.name}
                      </option>
                    );
                  })}
                </CustomInput>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default AlternativeAverageBarChart;
